module.exports = __webpack_public_path__ + "static/media/04.1c5841b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/04.jpg
// module id = 463
// module chunks = 0